// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { isoDateSchema, maskedContactSchema } from '../_shared/primitives'

export const sendCodeRequestSchema = z.object({
  mfaToken: z.string(),
  channel: z.enum(['sms', 'whatsapp', 'email', 'both']).optional(),
})
export type SendCodeRequest = z.infer<typeof sendCodeRequestSchema>

export const sendCodeResponseSchema = z.object({
  mfaToken: z.string(),
  channels: z.object({
    sms: maskedContactSchema.optional(),
    whatsapp: maskedContactSchema.optional(),
    email: maskedContactSchema.optional(),
  }),
  cooldownEndsAt: isoDateSchema,
  attemptsRemaining: z.number().optional(),
})
export type SendCodeResponse = z.infer<typeof sendCodeResponseSchema>
